import axios from "axios";
import settings from "../settings";

let initialState = {
    loadingCronLogsList: false,
    requestSuccess: false,
    requestError: false,
    drawerOpen: false,
    errorMessage: null,
    totalCronLogs: 0,
    cronLogs: [],
    loadingErrorLogsList: false,
    totalErrorLogs: 0,
    errorLogs: [],
    taskLogs: [],
    totalTaskLogs: 0,
    loadingTaskLogsList: false,
    tableOptions: null
};
export default {
    namespaced: true,
    state: { ...initialState },
    actions: {
        async getCronLogs({ commit, state }) {
            commit("setRequestError", false);
            commit("setRequestSuccess", false);
            commit("setCronLogsListLoading", true);
            try {
                let params = {
                    act: "cron-log",
                    page: state.tableOptions && state.tableOptions.page ? state.tableOptions.page : null,
                    itemsPerPage:
                        state.tableOptions && state.tableOptions.itemsPerPage ? state.tableOptions.itemsPerPage : null
                };
                let response = await axios.get(settings.api_url + "/logs/", {
                    params
                });
                let data = response.data;
                if (data.success === 1) {
                    commit("addCronLogs", data.cron_logs);
                    commit("addCronLogsTotal", data.total_cron_logs);
                }
                commit("setCronLogsListLoading", false);
            } catch (e) {
                console.log(e);
                commit("setCronLogsListLoading", false);
                commit("setRequestError", true);
                commit("setErrorMessage", "Failed");
            }
        },
        async getErrorLogs({ commit }) {
            commit("setRequestError", false);
            commit("setRequestSuccess", false);
            commit("setErrorLogsListLoading", true);
            try {
                let params = { act: "error-log" };
                let response = await axios.get(settings.api_url + "/logs/", {
                    params
                });
                let data = response.data;
                if (data.success === 1) {
                    commit("addErrorLogs", data.error_logs);
                    commit("addErrorLogsTotal", data.total_error_logs);
                }
                commit("setErrorLogsListLoading", false);
            } catch (e) {
                console.log(e);
                commit("setErrorLogsListLoading", false);
                commit("setRequestError", true);
                commit("setErrorMessage", "Failed");
            }
        },
        async getTaskLogs({ commit }) {
            commit("setRequestError", false);
            commit("setRequestSuccess", false);
            commit("setTaskLogsListLoading", true);
            try {
                let params = { act: "task-log" };
                let response = await axios.get(settings.api_url + "/logs/", {
                    params
                });
                let data = response.data;
                if (data.success === 1) {
                    commit("addTaskLogs", data.task_logs);
                    commit("addTaskLogsTotal", data.total_task_logs);
                }
                commit("setTaskLogsListLoading", false);
            } catch (e) {
                console.log(e);
                commit("setTaskLogsListLoading", false);
                commit("setRequestError", true);
                commit("setErrorMessage", "Failed");
            }
        }
    },
    mutations: {
        setRequestSuccess(state, bool) {
            state.requestSuccess = bool;
        },
        setRequestError(state, bool) {
            state.requestError = bool;
        },
        setErrorMessage(state, message) {
            state.errorMessage = message;
        },
        toggleDrawer(state, isOpen) {
            state.drawerOpen = isOpen;
        },
        addCronLogs(state, logs) {
            state.cronLogs = logs;
        },
        addCronLogsTotal(state, value) {
            state.totalCronLogs = value;
        },
        setCronLogsListLoading(state, value) {
            state.loadingCronLogsList = value;
        },
        addErrorLogs(state, logs) {
            state.errorLogs = logs;
        },
        addErrorLogsTotal(state, value) {
            state.totalErrorLogs = value;
        },
        setErrorLogsListLoading(state, value) {
            state.loadingErrorLogsList = value;
        },
        addTaskLogs(state, logs) {
            state.taskLogs = logs;
        },
        addTaskLogsTotal(state, value) {
            state.totalTaskLogs = value;
        },
        setTaskLogsListLoading(state, value) {
            state.loadingTaskLogsList = value;
        },
        setTableOptions(state, options) {
            state.tableOptions = options;
            this.dispatch("LogStore/getCronLogs");
        }
    }
};
